import { FC } from 'react'
import { useField } from 'react-final-form'

import TextArea from '../molecules/TextArea'

type Props = {
  isConfirm: boolean
  label?: string
  required?: boolean
  placeholder?: string
}

const NAME = 'question'

const QuestionField: FC<Props> = ({
  isConfirm,
  label = '質問事項',
  required = false,
  placeholder = '応募する職種や企業のことで気になることや不明点などで質問があれば記入してください。',
}) => {
  const {
    input: { value },
  } = useField(NAME)

  if (isConfirm && !value) return null

  return (
    <TextArea
      label={label}
      name={NAME}
      isConfirm={isConfirm}
      required={required}
      placeholder={placeholder}
    />
  )
}

QuestionField.displayName = 'question'

export default QuestionField
